import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import Form from '../../../../antd/form/Form/Form.jsx';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField.jsx';
import FormNumberField from '../../../../antd/form/FormNumberField/FormNumberField.jsx';
import FormTextEditor from '../../../../antd/form/FormTextEditor/FormTextEditor.jsx';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import FormRadioGroup from '../../../../antd/form/FormRadioGroup/FormRadioGroup.jsx';
import FormSelect from '../../../../antd/form/FormSelect/FormSelect.jsx';
import { emptyEditor, required, empty } from '../../../../antd/form/FormValidation.js';



const IngProjectsForm = ({
  onSubmit,
  initials,
  form,
  disabled = false,
  studyProgramsOptions = [],
  teachersOptions = [],
  additionalTeachersOptions = [],
  disableGuarantorSelection = false,
}) => {
  const { t } = useTranslation();

  const handleSubmit = (values) => {
    const cleanedValues = {
      ...values,
      min_students:
        values.min_students !== undefined && values.min_students !== null && values.min_students !== ''
          ? Number(values.min_students)
          : null,
      max_students:
        values.max_students !== undefined && values.max_students !== null && values.max_students !== ''
          ? Number(values.max_students)
          : null,
      notes: values.notes || null,
    };

    onSubmit(cleanedValues);
  };

  return (
    <Form form={form} onFinish={handleSubmit} initialValues={initials} disabled={disabled}>
      <FormTextField
        label={t('Názov projektu')}
        name="name"
        initialValue={initials.name}
        rules={[empty(t)]}
      />

      <FormTextField
        label={t('Skratka')}
        initialValue={initials.shortcut}
        name="shortcut"
        rules={[
          empty(t),
          {
            validator: async (_, value) => {
              if (!value) return Promise.resolve();
              if (value.length > 15) {
                return Promise.reject(new Error(t('Skratka môže mať najviac 15 znakov')));
              }
              return Promise.resolve();
            },
          },
        ]}
      />

      <FormSelect
        label={t('Garant projektu')}
        name="guarantor_id"
        placeholder={t('Vyberte garanta projektu')}
        options={teachersOptions}
        initialValue={initials.guarantor_id}
        disabled={disabled || disableGuarantorSelection}
        rules={[required(t)]}
      />

      <FormSelect
        label={t('Ďalší učitelia na projekte')}
        name="teacher_ids"
        placeholder={t('Vyberte učiteľov')}
        options={additionalTeachersOptions.length ? additionalTeachersOptions : teachersOptions}
        mode="multiple"
        initialValue={initials.teacher_ids}
      />

      <FormSelect
        label={t('Študijné programy')}
        name="study_program_ids"
        placeholder={t('Vyberte študijné programy')}
        options={studyProgramsOptions}
        mode="multiple"
        initialValue={initials.study_program_ids}
        rules={[required(t)]}
      />

      <FormTextEditor
        label={t('Popis')}
        name="description"
        initialValue={initials.description}
        collapsible={false}
        rules={[emptyEditor(t)]}
      />

      <FormItem label={t('Počet študentov')}>
        <Row gutter={[16]} align="middle">
          <Col>
            <span>
              <span style={{ color: '#ff4d4f', marginRight: 4 }}>*</span>
              {t('min.')}
            </span>
          </Col>
          <Col>
            <FormNumberField
              name="min_students"
              initialValue={initials.min_students}
              min={0}
              style={{ width: 120 }}
              onChange={(value) => {
                if (value === null || value === undefined) return;

                const currentMax = form.getFieldValue('max_students');
                // If max is not set yet or is lower than new min, set it to min
                if (currentMax === undefined || currentMax === null || currentMax < value) {
                  form.setFieldsValue({ max_students: value });
                }
              }}
              rules={[
                required(t),
                {
                  validator: async (_, value) => {
                    if (value === undefined || value === null || value === '') {
                      return Promise.resolve();
                    }
                    if (value < 0) {
                      return Promise.reject(new Error(t('Zadajte nezáporné číslo')));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            />
          </Col>

          <Col>
            <span>
              <span style={{ color: '#ff4d4f', marginRight: 4 }}>*</span>
              {t('max.')}
            </span>
          </Col>
          <Col>
            <FormNumberField
              name="max_students"
              initialValue={initials.max_students}
              min={0}
              style={{ width: 120 }}
              dependencies={['min_students']}
              rules={[
                required(t),
                {
                  validator: async (_, value) => {
                    if (value === undefined || value === null || value === '') {
                      return Promise.resolve();
                    }
                    if (value < 0) {
                      return Promise.reject(new Error(t('Zadajte nezáporné číslo')));
                    }

                    const min = Number(form.getFieldValue('min_students'));
                    if (!Number.isNaN(min) && value < min) {
                      return Promise.reject(
                        new Error(
                          t('Maximálny počet študentov musí byť väčší alebo rovný minimálnemu'),
                        ),
                      );
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            />
          </Col>
        </Row>
      </FormItem>
      <FormRadioGroup
        label={t('Aktívny')}
        name="active"
        initialValue={initials.active}
        options={[
          { label: t('Áno'), value: 'Áno' },
          { label: t('Nie'), value: 'Nie' },
        ]}
        rules={[required(t)]}
      />

      {!disabled && (
        <FormButtonsContainer>
          <FormButton submitOnClick={true} submitKey={'ip-projects'}>
            {t('Uložiť')}
          </FormButton>
        </FormButtonsContainer>
      )}
    </Form>
  );
};

export default IngProjectsForm;
